import { rangeData, TDefaultStaticDate } from 'constants/dateRange';

export const getDateRangeWithLabel = (label: TDefaultStaticDate) =>
  rangeData.find((item) => item.label === label);
